<template>
  <v-chart class="bar" :option="option" />
</template>

<script>
import { getVirtualImitationDateView } from "@/api/comd.js";
export default {
  data() {
    return {
      option: {
        grid: {
          top: "9%",
          left: "1%",
          right: "15%",
          bottom: "5%",
          //   containLabel: true,
        },
        xAxis: {
          type: "value",

          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
          {
            type: "category",
            inverse: true,
            axisTick: "none",
            axisLine: "none",
            show: true,
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: "16",
              },
            },
            data: ["11264人", "10456人", "9569人", "8456人", "6332人"],
          },
          {
            //名称
            type: "category",
            offset: -10,
            position: "left",
            axisLine: {
              show: false,
            },
            inverse: true,
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              color: ["#333"],
              align: "left",
              verticalAlign: "bottom",
              lineHeight: 50,
              fontSize: 16,
            },
            data: [
              "01.婴幼儿意外伤害隐患排查虚拟仿真",
              "02.婴幼儿个人用品卫生虚拟仿真",
              "03.婴幼儿9个月穿脱衣物虚拟仿真",
              "04.婴幼儿湿式清扫虚拟仿真",
              "05.婴幼儿3-6岁睡眠虚拟仿真",
            ],
          },
        ],
        series: [
          {
            zlevel: 1,
            type: "bar",
            barWidth: "13px",
            animationDuration: 1500,
            data: [
              {
                value: 90,
              },
              {
                value: 80,
              },
              {
                value: 70,
              },
              {
                value: 60,
              },
              {
                value: 50,
              },
            ],
            align: "center",
            itemStyle: {
              normal: {
                barBorderRadius: 30,
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#3977E6", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#37BBF8", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
          {
            type: "bar",
            barWidth: "13px",
            barGap: "-100%",
            data: [100, 100, 100, 100, 100],
            itemStyle: {
              normal: {
                color: "#ffffff19",
                // fontSize: 10,
                barBorderRadius: 30,
              },
            },
          },
        ],
      },
      dataview: [],
    };
  },
  created() {
    let _ = this;
    setInterval(() => {
      _.getVirtualImitationDateViewHandel();
    }, 1000 * 10);
  },
  methods: {
    async getVirtualImitationDateViewHandel() {
      let res = await getVirtualImitationDateView();
      this.dataview = res.data;
      let add = this.dataview.map((en) => {
        return en.value;
      });
      add = add.reduce((n, m) => n + m);
      this.option = {
        grid: {
          top: "9%",
          left: "1%",
          right: "15%",
          bottom: "5%",
          //   containLabel: true,
        },
        xAxis: {
          type: "value",

          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
          {
            type: "category",
            inverse: true,
            axisTick: "none",
            axisLine: "none",
            show: true,
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: "16",
              },
            },
            data: this.dataview.map((en) => `${en.value}人`),
          },
          {
            //名称
            type: "category",
            offset: -10,
            position: "left",
            axisLine: {
              show: false,
            },
            inverse: true,
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              color: ["#333"],
              align: "left",
              verticalAlign: "bottom",
              lineHeight: 50,
              fontSize: 16,
            },
            data: this.dataview.map((en) => en.name),
          },
        ],
        series: [
          {
            zlevel: 1,
            type: "bar",
            barWidth: "13px",
            animationDuration: 1500,
            data: this.dataview.map((en) => en.value),
            align: "center",
            itemStyle: {
              normal: {
                barBorderRadius: 30,
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#3977E6", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#37BBF8", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
          {
            type: "bar",
            barWidth: "13px",
            barGap: "-100%",
            data: this.dataview.map((en) => add),
            itemStyle: {
              normal: {
                color: "#ffffff19",
                // fontSize: 10,
                barBorderRadius: 30,
              },
            },
          },
        ],
      };
    },
  },
};
</script>

<style>
</style>